var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque-1",
    serifid: "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2989",
    d: "M2133.33,-0l-194.352,1919.78l-873.62,213.556l-871.215,-213.255l-194.146,-1920.08l2133.33,-0Z",
    style: {
      fill: "#264de4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2991",
    d: "M1772.59,1797.53l166.087,-1640.54l-872.014,-0l-0,1813.11l705.927,-172.568Z",
    style: {
      fill: "#2965f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2993",
    d: "M445.076,869.124l23.937,235.487l597.654,0l-0,-235.487l-621.591,0Z",
    style: {
      fill: "#ebebeb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2995",
    d: "M1066.67,392.487l-669.688,0l24.278,235.492l645.41,0l-0,-235.492Z",
    style: {
      fill: "#ebebeb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2997",
    d: "M1066.67,1725.72l-0,-245.008l-1.171,0.275l-297.439,-70.817l-19.014,-187.814l-268.097,-0l37.417,369.752l547.074,133.913l1.23,-0.301Z",
    style: {
      fill: "#ebebeb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3005",
    d: "M1394.61,1104.61l-31.001,305.412l-297.868,70.89l0,244.998l547.51,-133.799l4.017,-39.785l62.759,-619.967l6.517,-63.236l48.214,-476.637l-669.017,0l0,235.492l376.33,0l-24.301,241.145l-352.029,0l0,235.487l328.869,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.b5027a300da5dce6415b842527ea4c3d.svg";
export { ForwardRef as ReactComponent };